import { render } from "./CustomProduct.vue?vue&type=template&id=4bce5f4a"
import script from "./CustomProduct.vue?vue&type=script&lang=js"
export * from "./CustomProduct.vue?vue&type=script&lang=js"

import "./CustomProduct.vue?vue&type=style&index=0&id=4bce5f4a&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QBar from 'quasar/src/components/bar/QBar.js';
import QSpace from 'quasar/src/components/space/QSpace.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QForm from 'quasar/src/components/form/QForm.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QItemLabel from 'quasar/src/components/item/QItemLabel.js';
import QSkeleton from 'quasar/src/components/skeleton/QSkeleton.js';
import QCardActions from 'quasar/src/components/card/QCardActions.js';import ClosePopup from 'quasar/src/directives/close-popup/ClosePopup.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QDialog,QCard,QBar,QSpace,QBtn,QCardSection,QForm,QInput,QItem,QItemSection,QItemLabel,QSkeleton,QCardActions});qInstall(script, 'directives', {ClosePopup});
